import psl from "psl";
import { ATTRIBUTES, HOST_NAMES, TAGS } from "../models/constants";

export class MailUtils {
    static getItemRestId(): string {
        let itemId: string = "";
        if(Office.context.mailbox.item){
            itemId = Office.context.mailbox.item.itemId;
        }
        if (Office.context.mailbox.diagnostics.hostName === HOST_NAMES.OUTLOOK_IOS
            || Office.context.mailbox.diagnostics.hostName === HOST_NAMES.OUTLOOK_ANDROID) {
            // itemId is already REST-formatted.
            return itemId;
        } else {
            // convert to an item ID for API v2.0.
            return Office.context.mailbox.convertToRestId(
                itemId,
                Office.MailboxEnums.RestVersion.v2_0
            );
        }
    }

    static getFolderIds(xmlDoc: Document): string[] {
        let folderIds: string[] = [];

        let folders: HTMLCollection = xmlDoc.getElementsByTagName(TAGS.FOLDER);

        if (!folders || folders.length === 0) {
            folders = xmlDoc.getElementsByTagName(TAGS.T_FOLDER);
        }

        if (folders && folders.length > 0) {
            for (let i: number = 0; i < folders.length; i++) {
                const folder: Element = folders.item(i)!;
                let idElement: Element = folder.getElementsByTagName(TAGS.FOLDER_ID)[0];

                if (!idElement) {
                    idElement = folder.getElementsByTagName(TAGS.T_FOLDER_ID)[0];
                }

                if (idElement) {
                    folderIds.push(idElement.getAttribute(ATTRIBUTES.ID)!);
                }
            }
        }

        return folderIds;
    }

    static parseHtmlResponse(html: string): Document {
        let htmlDoc: Document;

        const parser: DOMParser = new DOMParser();
        htmlDoc = parser.parseFromString(html, "text/html");

        return htmlDoc;
    }

    static parseXmlResponse(xml: string): Document {
        let xmlDoc: Document;

        const parser: DOMParser = new DOMParser();
        xmlDoc = parser.parseFromString(xml, "text/xml");

        return xmlDoc;
    }

    static parseDomainFromURL(url: string): string {
        let domain: string = "";

        if (url) {
            if (url.toLocaleLowerCase().startsWith("mailto")) {
                const matches: RegExpMatchArray = url.match(/^mailto?\:(?:[^\/?#]+)@([^\/?#]+)/)!;
                domain = matches && matches[1];
            } else {
                const matches: RegExpMatchArray = url.match(/^https?\:\/\/([^\/?#]+)/)!;
                domain = matches && matches[1];
            }

            domain = MailUtils.getTopLevelDomain(domain);
        }

        return domain;
    }

    static parseMultiLevelDomain(domain: string): string {
        try {
            if(domain.includes('@'))
                domain = domain.split('@')[1];
            else if(domain.match(/^https?:\/\/(?:www\.)?([^\/?#]+)/))
                domain = new URL(domain).hostname;

            return psl.get(domain);

        } catch (e) {
            console.error('Invalid Domain', e);
            return '';
        }
    }

    static getTopLevelDomain(domain: string, getLastPart: boolean = false): string {
        const matches: RegExpMatchArray = domain.match(/(\w+)(\.[a-z]\w+$)/)!;
        return getLastPart ? (matches && matches[matches.length - 1]) :  (matches && matches[0]);
    }
}
